module.exports = __webpack_public_path__ + "static/media/2.40f6cfbc.jpg";